<template>
  <div class="streamer-type-card">
    <settings-card
      :config="config"
      @setting="settings"></settings-card>
    <company-business-category-modal ref="modal" />
  </div>
</template>
<script>
import SettingsCard from '../settings-card.vue'
import CompanyBusinessCategoryModal from './company-business-category-modal.vue'
import { cardMixin } from '../mixin'
export default {
  name: 'CompanyBusinessCategoryCard',
  components: { SettingsCard, CompanyBusinessCategoryModal },
  mixins: [cardMixin]
}
</script>
